export const getWindowData = () => window._THULEDATA || window._EXTRANETDATA;
